import { useState, useEffect } from 'react';
import ReportsView from './ReportsView';
import useUniversalStore from 'store/universalStore';
import useOffcanvasStore from 'store/offcanvasStore';
import { sendWAReminder } from 'utils';
import { formatMoney } from 'utils';
import { reminderAPI } from 'services';
import dayjs from 'dayjs';

const Footer = ({ account }) => {
    const { profile, accountId } = useUniversalStore((state) => state);
    const [reportLoading, setReportLoading] = useState({ pdf: false, excel: false });
    const { openOffcanvas } = useOffcanvasStore((state) => state);
    const [overdue, setOverdue] = useState(false);

    useEffect(() => {
        getOverdueStatus();
    }, [accountId]);

    const getOverdueStatus = async () => {
        const reminders = await reminderAPI.fetchReminder(accountId);
        if (reminders?.length > 0) {
            const reminderDate = new Date(reminders[0].get("date"));
            dayjs(reminderDate).isBefore(dayjs(new Date())) ? setOverdue(true) : setOverdue(false);
        } else {
            setOverdue(false);
        }
    }

    const scheduleReminder = () => {
        openOffcanvas("reminder");
    }

    if (!account) return null;

    return (
        <div className="sticky-bottom bg-app py-2 px-3 text-white d-flex">
            <div className="col-8 col-md-8 mt-2">
                <span className="fs-3">
                    Balance :
                    <span className="ms-4 fs-5 "><i>{formatMoney(account.get("balance"))}</i></span>
                </span>
            </div>
            <div className="col-4 col-md-4">
                <div className="row justify-content-end">
                    <div className="col-2">
                        <div className="btn btn-sm bg-app position-relative"
                            onClick={scheduleReminder} >
                            <i className="bi bi-alarm fs-2 text-white" />
                            {overdue && <span className="position-absolute py-2 top-0 start-100 translate-middle badge bg-danger fs-6">1</span>}

                            {/* {remainder?.get("date") ? */}
                        </div>

                    </div>
                    <div className="col-2">
                        <div className="btn btn-sm bg-app"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#rcTxnsView">
                            <i className="bi bi-arrow-repeat fs-2 text-white" />
                        </div>
                    </div>
                    <div className="col-2">
                        <div className="btn btn-sm bg-app dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <span className="d-flex align-items-center">
                                {reportLoading.pdf ?
                                    <span className="spinner-border text-white mt-2" role="status" aria-hidden="true" />
                                    : <i className="bi bi-file-pdf fs-2 text-white" />
                                }
                            </span>
                        </div>
                        <ReportsView setReportLoading={setReportLoading} type="pdf" />
                    </div>
                    <div className="col-2">
                        <div className="btn btn-sm bg-app dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <span className="d-flex align-items-center">
                                {reportLoading.excel ?
                                    <span className="spinner-border text-white mt-2" role="status" aria-hidden="true" />
                                    : <i className="bi bi-filetype-xls fs-2 text-white" />
                                }
                            </span>
                        </div>
                        <ReportsView setReportLoading={setReportLoading} type="excel" />
                    </div>
                    <div className="col-2">
                        <div className="btn btn-sm bg-app"
                            title="Remind" onClick={() => sendWAReminder(account)}>
                            <i className="bi bi-whatsapp fs-2 text-white" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;